//Stateler çekilip return edilecek

export const getReportLoading = (state) => {
    return state.loading
}

export const signalReport = (state) => {
    return state.signalReport
}

export const reportStatus = (state) => {
    return state.status
}

export const getColumns = (state) => {
    return state.columns
}

export const flexReport = (state) => {
    return state.flexReport
}


// WEBPACK FOOTER //
// ./src/store/modules/Reports/Getters.js